import { render, staticRenderFns } from "./previewMarketing.vue?vue&type=template&id=2c184397&scoped=true"
import script from "./previewMarketing.vue?vue&type=script&lang=js"
export * from "./previewMarketing.vue?vue&type=script&lang=js"
import style0 from "./previewMarketing.vue?vue&type=style&index=0&id=2c184397&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c184397",
  null
  
)

export default component.exports